import {responseToData, unRestangularize} from 'shared/utils/data-service-utils';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {FinishedSaveResponse, TransferableSettingsValue, ViewableSettingChain} from 'typings/portaro.be.types';

export default class SettingsDataService {
    public static readonly serviceName = 'settingsDataService';

    private static readonly SETTINGS_ROUTE = 'settings';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    @ngAsync()
    @unRestangularize()
    public async getSettingsByIds(settingIds = [] as string[]): Promise<ViewableSettingChain[]> {
        try {
            return await this.Restangular
                .one(SettingsDataService.SETTINGS_ROUTE)
                .get({setting: settingIds});
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async getSettings(sectionId: string): Promise<ViewableSettingChain[]> {
        try {
            return await this.Restangular
                .one(SettingsDataService.SETTINGS_ROUTE)
                .get({section: sectionId});
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async saveSettings(transferableSettings: TransferableSettingsValue): Promise<FinishedSaveResponse<ViewableSettingChain>> {
        try {
            return await this.Restangular
                .one(SettingsDataService.SETTINGS_ROUTE)
                .post(null, transferableSettings);
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async deleteSettings(settingsId: string): Promise<FinishedSaveResponse<ViewableSettingChain>> {
        try {
            return this.Restangular
                .one(SettingsDataService.SETTINGS_ROUTE, settingsId)
                .remove();
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }
}